export interface OpmlFeed {
  url: string
  title: string
  description?: string
  htmlUrl?: string
  category?: string
}

export function parseOpmlFeeds(xml: string): OpmlFeed[] {
  const parser = new DOMParser()
  const doc = parser.parseFromString(xml, "text/xml")

  const errorNode = doc.querySelector("parsererror")
  if (errorNode) {
    throw new Error("Invalid OPML XML format")
  }

  const feeds: OpmlFeed[] = []
  const outlines = doc.querySelectorAll("outline")

  for (const outline of outlines) {
    const type = outline.getAttribute("type")
    const xmlUrl = outline.getAttribute("xmlUrl")

    if (type === "rss" && xmlUrl) {
      const title =
        outline.getAttribute("text") || outline.getAttribute("title") || xmlUrl
      const description = outline.getAttribute("description") || undefined
      const htmlUrl = outline.getAttribute("htmlUrl") || undefined
      const category = outline.getAttribute("category") || undefined

      feeds.push({
        url: xmlUrl,
        title,
        description,
        htmlUrl,
        category,
      })
    }
  }

  return feeds
}

export function generateOpmlFeeds(
  feeds: OpmlFeed[],
  title = "Feed Subscriptions",
): string {
  const now = new Date().toUTCString()

  const outlines = feeds
    .map(feed => {
      const attrs = [
        `text="${escapeXml(feed.title)}"`,
        `title="${escapeXml(feed.title)}"`,
        `type="rss"`,
        `xmlUrl="${escapeXml(feed.url)}"`,
      ]

      if (feed.description) {
        attrs.push(`description="${escapeXml(feed.description)}"`)
      }

      if (feed.htmlUrl) {
        attrs.push(`htmlUrl="${escapeXml(feed.htmlUrl)}"`)
      }

      if (feed.category) {
        attrs.push(`category="${escapeXml(feed.category)}"`)
      }

      return `    <outline ${attrs.join(" ")} />`
    })
    .join("\n")

  return `<?xml version="1.0" encoding="UTF-8"?>
<opml version="2.0">
  <head>
    <title>${escapeXml(title)}</title>
    <dateCreated>${now}</dateCreated>
    <dateModified>${now}</dateModified>
  </head>
  <body>
${outlines}
  </body>
</opml>`
}

function escapeXml(str: string): string {
  return str
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;")
}
